import { toast } from "react-toastify";
import { action, observable } from "mobx";
import { api } from "../../api";
import { ICalc, IEmpresa, IMemoria, IMemoriaCalculo, newEmpresa, newIMemoria } from "../../model";

export class _MemoriaStore {
  obs = observable({
    memoria_calculo: [] as IMemoriaCalculo[],
    result_ok: false as boolean,
    memoria_length: 0 as number,
    current_page: 1 as number,
    modelo: "nfe" as string,
    loading: false as boolean,
    filters: {
      "cest": "",
      "ncm": "",
      "cfop": "",
      "cnpj_origem": "",
      "cnpj_destino": "",
      "descricao": "",
      "cod_trib_nacional": "",
    },
    estado: "PA" as string,
    entrada_saida: "entrada" as string,
    deletarMemorias: [] as any,
    loading_delete: false as boolean,
    // Estado compartilhado entre as abas de modelo (sobrevive à troca de aba)
    select_empresa: newEmpresa() as IEmpresa,
    open_create: false as boolean,
    create_memoria: newIMemoria() as IMemoria,
    calcOptions: [] as any,
    calc_selecionado: null as ICalc,
    open_ajuda: false as boolean,
  })

  resetFilters() {
    this.obs.filters = {
      "cest": "",
      "ncm": "",
      "cfop": "",
      "cnpj_origem": "",
      "cnpj_destino": "",
      "descricao": "",
      "cod_trib_nacional": "",
    }
  }

  async handleMemorias(params) {

    try {

      let resp = await api.post("/api/memoria-contestacoes", params);

      if (resp.data.itens.length > 0) {

        this.obs.memoria_length = resp.data.count
        this.obs.memoria_calculo = resp.data.itens;

      } else {

        this.obs.memoria_length = 0
        this.obs.current_page = 1
        this.obs.memoria_calculo = [];

      }

    } catch (ex) {

      toast.error("Erro ao filtrar Memória Contestações, tente novamente mais tarde.", {});

    }

  }
  resetDeletarItems() {
    this.obs.deletarMemorias = [];
  }

  async handleDeleteMemorias() {

    this.obs.loading_delete = true

    try {

      let resp = await api.post('/api/memoria-contestacoes/delete', { memorias: this.obs.deletarMemorias, modelo: this.obs.modelo })

      if (resp.data.ok) {

        toast.success(`Memórias deletadas com sucesso!`, {});

        this.obs.deletarMemorias = []

        this.obs.loading_delete = false

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Lote Memória Contestações, tente novamente mais tarde.", {});

    }

    this.obs.loading_delete = false

    return false

  }

  async handleCreateMemoria(data) {

    try {

      let resp = await api.post('/api/memoria-contestacoes/create', data)

      if (resp.data.ok) {

        toast.success(`Memória criada com sucesso!`, {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Lote Memória Contestações, tente novamente mais tarde.", {});

    }

    return false

  }

  async handleUpdateMemoria(data) {

    try {

      let resp = await api.post('/api/memoria-contestacoes/update', data)

      if (resp.data.ok) {

        toast.success(`Memória criada com sucesso!`, {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Lote Memória Contestações, tente novamente mais tarde.", {});

    }

    return false

  }

}

export const MemoriaStore = new _MemoriaStore();
